import React, { useState } from 'react';
import QuoteBuilder from './QuoteBuilder';
import OrgRegistration from './OrgRegistration';
import ARRDashboard from './ARRDashboard';
import LiveTaskAnalytics from './LiveTaskAnalytics';
import CrmSyncTab from './CrmSyncTab';
import PayoutsTab from './PayoutsTab';
import SalesTouchpoints from './SalesTouchpoints';
import LocationOnboarding from './LocationOnboarding';
import { fetchFromDentalAPI } from './common';
import './NewDashboard.css';

const CreateInternalAccount = () => {
  const [email, setEmail] = useState('');
  const [organizationId, setOrganizationId] = useState('');
  const [status, setStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!email || !organizationId) {
      setStatus('Please enter both email and organization ID');
      return;
    }

    try {
      setSubmitting(true);
      setStatus('Sending registration email…');

      const data = await fetchFromDentalAPI('/api/send-org-registration', {
        method: 'POST',
        body: JSON.stringify({ email, organizationId }),
      });

      setStatus(data.message || `Registration email sent (${data.practiceCount} practices)`);
      setEmail('');
      setOrganizationId('');
    } catch (err) {
      setStatus(err.message || 'Error sending registration email');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="nd-card">
      <h2 className="nd-card-title">Create Internal Account</h2>
      <p className="nd-card-desc">Send a registration email to a new user. All practice IDs for the organization are automatically included.</p>

      <div className="nd-form-row">
        <div className="nd-form-group">
          <label>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="user@example.com" />
        </div>
        <div className="nd-form-group">
          <label>Organization ID</label>
          <input type="text" value={organizationId} onChange={e => setOrganizationId(e.target.value)} placeholder="org-123456" />
        </div>
      </div>

      <button className="nd-submit-btn" onClick={handleSubmit} disabled={submitting}>
        {submitting ? 'Sending…' : 'Send Registration Email'}
      </button>
      {status && <div className="nd-status">{status}</div>}
    </div>
  );
};

const NewDashboard = ({ onSwitchToLegacy }) => {
  const [activeTab, setActiveTab] = useState('quoteBuilder');

  return (
    <div className="nd-container">
      <div className="nd-header">
        <div className="nd-header-left">
          <img src="/newton-logo.png" alt="Newton" style={{ height: 32 }} />
          <button className="nd-legacy-btn" onClick={onSwitchToLegacy}>
            ← Return to Legacy Interface
          </button>
        </div>
      </div>

      <div className="nd-tabs">
        <button className={`nd-tab ${activeTab === 'locationOnboarding' ? 'nd-tab-active' : ''}`} onClick={() => setActiveTab('locationOnboarding')}>Location Onboarding</button>
        <button
          className={`nd-tab ${activeTab === 'quoteBuilder' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('quoteBuilder')}
        >
          Quote Builder
        </button>
        <button
          className={`nd-tab ${activeTab === 'createAccount' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('createAccount')}
        >
          Create Internal Account
        </button>
        <button
          className={`nd-tab ${activeTab === 'adminReg' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('adminReg')}
        >
          Generate Admin Registration URL
        </button>
        <button
          className={`nd-tab ${activeTab === 'arr' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('arr')}
        >
          ARR
        </button>
        <button
          className={`nd-tab ${activeTab === 'liveTasks' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('liveTasks')}
        >
          Customer KPI
        </button>
        <button
          className={`nd-tab ${activeTab === 'crmSync' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('crmSync')}
        >
          CRM Sync
        </button>
        <button
          className={`nd-tab ${activeTab === 'salesTouchpoints' ? 'nd-tab-active' : ''}`}
          onClick={() => setActiveTab('salesTouchpoints')}
        >
          Sales Touchpoints
        </button>
      </div>

      <div className="nd-content">
        {activeTab === 'locationOnboarding' && <LocationOnboarding />}
        {activeTab === 'quoteBuilder' && <QuoteBuilder />}
        {activeTab === 'createAccount' && <CreateInternalAccount />}
        {activeTab === 'adminReg' && <OrgRegistration />}
        {activeTab === 'arr' && <ARRDashboard />}
        {activeTab === 'liveTasks' && <LiveTaskAnalytics />}
        {activeTab === 'crmSync' && <CrmSyncTab />}
        {activeTab === 'payouts' && <PayoutsTab />}
        {activeTab === 'salesTouchpoints' && <SalesTouchpoints />}
      </div>
    </div>
  );
};

export default NewDashboard;
